import type { ReactNode } from 'react'

import { getCurrentLanguage, useTT } from './translation-memory'

interface TranslatedTextProps {
  children: ReactNode
  /** An explicit per-language map — a product's `nameI18n`, say. Wins over the memory. */
  i18n?: Record<string, string> | null
  fallback?: string
}

/**
 * Wrap any Slovak literal to make it translatable, ported from legacy
 * `components/T.tsx`.
 *
 *   <T>Uložiť</T>                                 a static Slovak literal
 *   <T>{product.name}</T>                         dynamic, looked up in memory
 *   <T i18n={product.nameI18n}>{product.name}</T>  explicit map wins
 *
 * Non-string children pass through untouched, which is what lets it wrap
 * interpolated fragments without swallowing them.
 */
export function T({ children, i18n, fallback }: TranslatedTextProps) {
  const translate = useTT()

  if (typeof children !== 'string') return <>{children}</>

  const language = getCurrentLanguage()
  const explicit = i18n?.[language]
  if (i18n && language !== 'sk' && typeof explicit === 'string' && explicit) {
    return <>{explicit}</>
  }

  return <>{translate(children) || fallback || children}</>
}
